import React from 'react';

const TimeSelect = ({ register, name, interval = 5, format12Hour = false }) => {
  // Helper to convert 24h time to 12h format with AM/PM
  const formatTime12Hour = (hour, min) => {
    const period = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    const m = String(min).padStart(2, '0');
    return `${hour12}:${m} ${period}`;
  };

  // Generate time options dynamically based on interval and format
  const generateTimeOptions = (interval) => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let min = 0; min < 60; min += interval) {
        const h24 = String(hour).padStart(2, '0');
        const m = String(min).padStart(2, '0');
        const value = `${h24}:${m}`;
        const label = format12Hour ? formatTime12Hour(hour, min) : value;
        times.push({ value, label });
      }
    }
    return times;
  };

  const times = React.useMemo(() => generateTimeOptions(interval), [interval, format12Hour]);

  return (
    <select
      {...register(name)}
      className="w-full border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:border-blue-500"
    >
      {times.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default TimeSelect;
